<template>
  <div class="wrapper clickable" @click="displayMedia()">
    <div class="icon">
      <i class="fas fa-file-pdf fa-3x"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    url () {
      return this.item.media[0].url
    }
  },
  methods: {
    displayMedia () {
      window.open(this.url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  margin-right: $spacing-sm;
  height: 8rem;
  width: 15rem;
  display:flex;
  justify-content:center;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.icon {
  color: $medium-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/pdf.vue